import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'

import { CompTextWrapperCore } from '../core/text/wrapper'

/**
 * CompTextWrapper
 */
const CompTextWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // action
  const actionContext = useBuilderActionContextV2()

  return <CompTextWrapperCore infos={infosProps} action={actionContext} />
}

export default CompTextWrapper
